import { render, staticRenderFns } from "./LabSelection.vue?vue&type=template&id=bd0121c2&scoped=true"
import script from "./LabSelection.vue?vue&type=script&lang=js"
export * from "./LabSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0121c2",
  null
  
)

export default component.exports